// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1G6Wy","container":"Footer_container__395Ja","content":"Footer_content___nbDw","image":"Footer_image__1-gLm"};